import { authClient, API } from '../index'

// Get all therapeuticGroups
export const getTherapeuticGroups = () => {
  return authClient().get(`${API}/therapeuticGroup`)
}
export const getTherapeuticGroupsByTherapist = (_id) => {
  return authClient().get(`${API}/therapeuticGroup/therapist/${_id}`)
}

// Get therapeuticGroup by id
export const getTherapeuticGroupById = (id) => {
  return authClient().get(`${API}/therapeuticGroup/${id}`)
}

// Delete therapeuticGroup
export const deleteTherapeuticGroup = (id) => {
  return authClient().delete(`${API}/therapeuticGroup/${id}`)
}

// Create therapeuticGroup
export const postTherapeuticGroup = (therapeuticGroup) => {
  return authClient().post(`${API}/therapeuticGroup`, therapeuticGroup)
}

// Update therapeuticGroup
export const updateTherapeuticGroup = (id, therapeuticGroup) => {
  return authClient().put(`${API}/therapeuticGroup/${id}`, therapeuticGroup)
}

export const changeStatusTherapeuticGroup = (id, active) => {
  return authClient().put(`${API}/therapeuticGroup/change-status/${id}`, { active });
}